import React, { FC } from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import { StarIcon } from '@/public/icons';
import { devices } from '@/styles/breakpoints';
import { TitleH3 } from '@/styles/typography';
import { RegularText } from '@/styles/typography';
import { ArticleType, IArticle } from '@/types/articles';

export const Article: FC<{ item: IArticle }> = ({ item }): JSX.Element => {
  return (
    <ArticleWrapper $isverticalview={item.type === ArticleType.VERICAL}>
      <ContentWrapper isHasList={!!item?.list?.length}>
        <IconWrapper>
          <StarIcon width={24} height={24} />
        </IconWrapper>

        <TagText>{item.tag}</TagText>
        <Title>{item.title}</Title>
        <RegularText>{item.text}</RegularText>
        {!!item?.list?.length && (
          <ListItems>
            {item.list.map((item, idx) => (
              <ListItem key={idx}>
                <RegularText>{item.text}</RegularText>
              </ListItem>
            ))}
          </ListItems>
        )}

        {/* <Link href={`/${item.path}`}>
          <MoreBtn>
            <span>Learn More</span>
            <ArrowRight />
          </MoreBtn>
        </Link> */}
      </ContentWrapper>
      <ImageWrapper>
        <Image
          width={472}
          height={300}
          src={item.image.path}
          alt={item.image.alt}
        />
      </ImageWrapper>
    </ArticleWrapper>
  );
};

const Title = styled(TitleH3)`
  margin-bottom: 16px;
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;
`;

const ArticleWrapper = styled.article<{ $isverticalview: boolean }>`
  padding: 16px;
  gap: 24px;
  background-color: rgba(246, 247, 249, 1);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 548px;
  margin: 0 auto;

  @media only screen and ${devices.largeDesktop} {
    padding: 40px;
    ${(props) =>
      props.$isverticalview
        ? `

      
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 548px;
        `
        : `

      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      max-width:100%;
      gap:24px;
     
        `}
  }
  & div {
    width: 100%;
  }

  & img {
    border-radius: 10px;
  }
  & .navigation-link {
    text-decoration: none;
  }
`;

const ImageWrapper = styled.div`
  display: contents;
  & img {
    width: 100%;
    height: auto;
    margin: 0 auto;
    max-width: 472px;
    max-height: 300px;
  }
`;

const ContentWrapper = styled.div<{ isHasList: boolean }>`
  min-height: ${(props) => (props.isHasList ? '320px' : '270px')};
`;

const ListItems = styled.ul`
  padding-left: 20px;
  margin-bottom: 16px;
`;
const ListItem = styled.li``;

const TagText = styled(RegularText)`
  margin-bottom: 8px;
  font-size: clamp(14px, 4vw, 16px);
  font-weight: ${({ theme }) => theme?.fonts?.semibold600};
  line-height: 24px;
`;
